import { Modal } from 'antd';
import React from 'react';

export const ModalTheme = (props) => {
  const { open, title, onToggle, children,width,maskClosable,closable,keyboard, footer, destroyOnClose } = props;
  return (
    <Modal
      title={title || null}
      open={open}
      onOk={onToggle}
      onCancel={onToggle}
      maskClosable={maskClosable || false}
      closable={closable || false}
      keyboard={keyboard || false} 
      destroyOnClose={destroyOnClose !== undefined ? destroyOnClose : false}
      footer={footer !== undefined ? footer : null}
      width={width || '100%'}
    >
      {children}
    </Modal>
  );
};
